<template>
    <Link :with-modal="!props.notModal"
          :href="route('work.show', {work: item.id})"
          class="item"
          :style="{
              width: props.width
          }">
        <img class="item-img" :src="item.cover.url">
        <div class="details">
            <div class="details-top">
                <div v-if="props.showName" class="name">{{ item.name }}</div>
                <UserPopover v-else :user="item.owner_user">
                    <Link :href="route('user.show', {uid: item.owner_user.uid})">
                        <img class="user-img" :src="item.owner_user.avatar.url">
                    </Link>
                </UserPopover>
            </div>
            <div class="details-bottom">
                <div class="operate">
                    <div class="operate-button">免费下载</div>
                    <Collect :collect-url="route('api.work.collect',{work: item.id})"
                             :is-collected="item.collect_status">
                        <template #collected>
                            <div class="operate-button">已收藏</div>
                        </template>
                        <template #unCollected>
                            <div class="operate-button">收藏</div>
                        </template>
                    </Collect>
                </div>
                <div class="record">
                    <div class="info">
                        <span class="pt-icons-visit"></span>
                        <div class="info-span">{{ item.view_count }}</div>
                    </div>
                    <div class="info">
                        <span class="pt-icons-comment"></span>
                        <div class="info-span">{{ item.comments_count }}</div>
                    </div>
                    <div class="info">
                        <Like :like-url="route('api.work.like',{work: item.id})" :is-like="item.like_status">
                            <template #liked>
                                <i class="pt-icons-pickup active"></i>
                                <div class="info-span">{{ item.likes_count + 1 }}</div>
                            </template>
                            <template #unLiked>
                                <i class="pt-icons-pickup"></i>
                                <div class="info-span">{{ item.likes_count }}</div>
                            </template>
                        </Like>
                    </div>
                </div>
            </div>
        </div>
    </Link>
</template>

<script setup lang="ts">
import Link from "@/Components/Link.vue";
import {route} from "@/utils/common";
import UserPopover from "@/Components/Common/UserPopover.vue";
import Like from "@/Components/Like.vue";
import Collect from "@/Components/Collect.vue";

const props = withDefaults(defineProps<{
    item: any
    showName: boolean
    notModal: boolean
    width?: string
}>(), {
    width: '316px',
})

</script>

<style scoped lang="less">
.item {
    min-height: 200px;
    display: flex;
    position: relative;
    align-items: center;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0);
        transition: background-color .3s;
    }

    &:hover {
        &::before {
            background-color: rgba(0, 0, 0, .2);
        }

        .details {
            opacity: 1;
        }
    }

    .item-img {
        width: 100%;
        vertical-align: top;
        //border-radius: 10px;
    }

    .details {
        opacity: 0;
        transition: all .3s;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        .details-top {
            width: 100%;
            display: flex;
            justify-content: center;
            position: absolute;
            top: 20px;

            .name {
                color: #FFFFFF;
                font-size: 16px;
            }

            .user-img {
                width: 39px;
                height: 39px;
                border-radius: 50%;
            }
        }

        .details-bottom {
            position: absolute;
            bottom: 20px;
            width: 100%;

            .operate {
                display: flex;
                align-items: center;
                justify-content: center;

                .operate-button {
                    width: 90px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #ffffff;
                    font-size: 14px;
                    color: #2E2E2E;
                    border-radius: 6px;
                    margin: 0 7px 16px;
                    transition: all .3s;

                    &:hover {
                        opacity: .8;
                    }
                }
            }

            .record {
                display: flex;
                align-items: center;
                justify-content: center;

                .info {
                    display: flex;
                    align-items: center;
                    margin: 0 15px;

                    .pt-icons-visit {
                        color: #FFFFFF;
                        font-size: 16px;
                    }

                    .pt-icons-comment {
                        color: #FFFFFF;
                        font-size: 16px;
                    }

                    .pt-icons-pickup {
                        color: #FFFFFF;
                        font-size: 16px;

                        &.active {
                            color: #FF5967;
                        }
                    }

                    .info-span {
                        margin: -1px 0 0 10px;
                        font-size: 14px;
                        color: #ffffff;
                    }
                }
            }
        }
    }
}
</style>
